export default __webpack_public_path__ + "static/media/plusCircle.6ecc3411.svg";